import { VvsInstallationProduct } from 'models/InstallationConfigurator';
import { RadioButtonProps } from 'components/Shared/Form';
import { rm, NO_ELEMENT, hasElements } from 'utils';
import React from 'react';
import { AddonSectionProps } from '../../../addonSectionProps';
import { InstallationAddon } from '../../../themes/BGH/installationAddon';

type VvsAddonProductProps = VvsInstallationProduct &
  Pick<RadioButtonProps, 'onChange'> & { name?: string };

export const VvsAddonProduct = ({
  title,
  productId,
  onChange,
  selected,
  price,
  pdf
}: VvsAddonProductProps & { isCheckbox?: boolean }) => {
  const groupName = '';

  return (
    <InstallationAddon
      tooltip={{
        type: 'pdf',
        pdf
      }}
      title={title}
      value={productId}
      name={groupName}
      onClick={onChange}
      isSelected={selected}
      price={price}
    />
  );
};

interface VvsAddonSectionProps extends AddonSectionProps {
  addonProducts: VvsInstallationProduct[];
}

interface SingleAddonCheckboxProps
  extends Pick<VvsAddonSectionProps, 'addonProducts' | 'selectAddon'> {
  groupName: string;
}

const SingleAddonCheckbox = ({
  addonProducts,
  groupName,
  selectAddon
}: SingleAddonCheckboxProps) => {
  if (!hasElements(addonProducts)) {
    return NO_ELEMENT;
  }

  const [addonProduct] = addonProducts;
  const { selected, productId, price } = addonProduct;

  const onChange = () => selectAddon(selected ? '' : productId);

  return (
    <InstallationAddon
      title={rm('productpage_select_removal')}
      isSelected={selected}
      price={price}
      name={groupName}
      onClick={onChange}
      value={productId}
      isCheckbox
    />
  );
};

export const VvsAddonSection = ({
  addonProducts,
  installationSelected,
  selectAddon
}: VvsAddonSectionProps) => {
  const hasAddons = addonProducts.length > 0;
  const groupName = hasAddons ? `${addonProducts[0].installationId}_REMOVE` : '';

  if (!hasAddons || !installationSelected) {
    return NO_ELEMENT;
  }

  return (
    <SingleAddonCheckbox
      addonProducts={addonProducts}
      groupName={groupName}
      selectAddon={selectAddon}
    />
  );
};
